export const ROUTES = {
  HOME: "/",
  CONTENT: "/content",
  RESUME: "/resume.pdf",
};
